<section class="table-responsive">
  <!-- Tabela -->
  <div class="row mb-1">
    <div class="col-sm-12">
      <table
        id="users-contacts"
        class="table table-middle dataTable table-white-space"
        role="grid"
        aria-describedby="users-contacts_info">
        <thead class="white text-center">
          <tr>
            <th *ngFor="let coluna of colunasTabela">
              <ng-container *ngIf="coluna.pipe === 'checkbox_selecao'; else textoTitulo">
                <i
                  *ngIf="todosSelecionados()"
                  (click)="toggleTodos({target: {checked: false}})"
                  class="fa fa-check-square text-info cursor-pointer font-medium-3"></i>
                <i
                  *ngIf="!todosSelecionados()"
                  (click)="toggleTodos({target: {checked: true}})"
                  class="fa fa-square-o text-muted cursor-pointer font-medium-3"></i>
              </ng-container>
              <ng-template #textoTitulo>{{ coluna.titulo }}</ng-template>
            </th>
            <th *ngIf="mostrarColunaStatus">Status</th>
            <th *ngIf="mostrarColunaAcao">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaTabela | paginate: config; let i = index">
            <!-- Dinâmica -->
            <td
              class="text-center"
              *ngFor="let coluna of colunasTabela"
              [ngbTooltip]="retornaValorTooltip(item, coluna)"
              container="body"
              tooltipClass="tooltip-custom">
              <!-- Checkbox Seleção -->
              <ng-container *ngIf="coluna.pipe === 'checkbox_selecao'">
                <i
                  *ngIf="item.selecionado"
                  (click)="item.selecionado = false; onCheckboxChange(item)"
                  class="fa fa-check-square text-info cursor-pointer font-medium-3"></i>
                <i
                  *ngIf="!item.selecionado"
                  (click)="item.selecionado = true; onCheckboxChange(item)"
                  class="fa fa-square-o text-muted cursor-pointer font-medium-3"></i>
              </ng-container>
              <!-- Contador Itens -->
              <ng-container *ngIf="coluna.pipe == 'contador'">
                <span>{{ contarItens(item) }}</span>
              </ng-container>
              <!-- Sem pipe -->
              <ng-container *ngIf="!coluna.pipe">
                <span>{{ retornaValorCampo(item, coluna.campo) | SliceStringNamePipe }} {{ coluna.complemento }}</span>
              </ng-container>
              <!-- Pipe CPF -->
              <ng-container *ngIf="coluna.pipe === 'cpf'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semCpf">
                  {{ retornaValorCampo(item, coluna.campo) | cpf }}
                </span>
                <ng-template #semCpf>-</ng-template>
              </ng-container>
              <!-- Pipe CNPJ -->
              <ng-container *ngIf="coluna.pipe === 'cnpj'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semCnpj">
                  {{ retornaValorCampo(item, coluna.campo) | cnpj }}
                </span>
                <ng-template #semCnpj>-</ng-template>
              </ng-container>
              <!-- Pipe RG -->
              <ng-container *ngIf="coluna.pipe === 'rg'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semRg">
                  {{ retornaValorCampo(item, coluna.campo) | mask: '00.000.000-0' }}
                </span>
                <ng-template #semRg>-</ng-template>
              </ng-container>
              <!-- Pipe Carteirinha -->
              <ng-container *ngIf="coluna.pipe === 'cardNumber'">
                {{ retornaValorCampo(item, coluna.campo) | mask: '0 000 000000000000 0' }}
              </ng-container>
              <!--Pipe CEP -->
              <ng-container *ngIf="coluna.pipe === 'cep'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semCEP">
                  {{ retornaValorCampo(item, coluna.campo) | mask: '00000-000' }}
                </span>
                <ng-template #semCEP>-</ng-template>
              </ng-container>
              <!--Pipe Data -->
              <ng-container *ngIf="coluna.pipe === 'date'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semData">
                  {{ retornaValorCampo(item, coluna.campo) | date: 'dd/MM/yyyy' }}
                </span>
                <ng-template #semData>-</ng-template>
              </ng-container>
              <!--  Pipe Data e Hora -->
              <ng-container *ngIf="coluna.pipe === 'dateTime'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semDataHora">
                  {{ retornaValorCampo(item, coluna.campo) | date: 'dd/MM/yyyy - HH:mm' }}
                </span>
                <ng-template #semDataHora>-</ng-template>
              </ng-container>
              <!--Pipe Idade -->
              <ng-container *ngIf="coluna.pipe === 'age'">
                {{ calcularIdadePessoa(item, coluna.campo) }}
              </ng-container>
              <!--Pipe Celular -->
              <ng-container *ngIf="coluna.pipe === 'cellPhone'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semCelular">
                  {{ retornaValorCampo(item, coluna.campo) | mask: '(00) 00000-0000' }}
                </span>
                <ng-template #semCelular>-</ng-template>
              </ng-container>
              <!--Pipe Telefone-->
              <ng-container *ngIf="coluna.pipe === 'telephone'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semTelefone">
                  {{ retornaValorCampo(item, coluna.campo) | mask: '(00) 0000-0000' }}
                </span>
                <ng-template #semTelefone>-</ng-template>
              </ng-container>
              <!--Pipe Valor -->
              <ng-container *ngIf="coluna.pipe === 'value'">
                {{ retornaValorCampo(item, coluna.campo) | currency: 'BRL' }}
              </ng-container>
              <!--Pipe Porcentagem -->
              <ng-container *ngIf="coluna.pipe === 'porcentagem'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semValor">
                  {{ retornaValorCampo(item, coluna.campo) }} %
                </span>
                <ng-template #semValor>0%</ng-template>
              </ng-container>
              <!-- Pipe Badge Porcentagem Sucesso (Verde) -->
              <ng-container *ngIf="coluna.pipe === 'badge_porcentagem_sucesso' || coluna.pipe === 'badge_verde_porcentagem'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semValorBadgeSucesso" class="badge badge-success round font-small-2">
                  <i class="fa fa-arrow-up mr-1" *ngIf="item[coluna.campo] > 0"></i>
                  {{ retornaValorCampo(item, coluna.campo) }}%
                </span>
                <ng-template #semValorBadgeSucesso>
                  <span class="badge badge-secondary round font-small-2">0%</span>
                </ng-template>
              </ng-container>
              <!-- Pipe Badge Porcentagem Info (Azul) -->
              <ng-container *ngIf="coluna.pipe === 'badge_porcentagem_info' || coluna.pipe === 'badge_azul_porcentagem'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semValorBadgeInfo" class="badge badge-info round font-small-2">
                  <i class="fa fa-arrow-up mr-1" *ngIf="item[coluna.campo] > 0"></i>
                  {{ retornaValorCampo(item, coluna.campo) }}%
                </span>
                <ng-template #semValorBadgeInfo>
                  <span class="badge badge-secondary round font-small-2">0%</span>
                </ng-template>
              </ng-container>
              <!-- Pipe Corretora -->
              <ng-container *ngIf="coluna.pipe === 'corretora'">
                <span *ngIf="retornaValorCampo(item, coluna.campo) !== '-'; else semCorretora">
                  {{ retornaValorCampo(item, coluna.campo) | SliceStringNamePipe }}
                </span>
                <ng-template #semCorretora>
                  <span class="badge bold badge-danger round">SEM CORRETORA</span>
                </ng-template>
              </ng-container>
              <!-- Pipe Liminar (Sim/Não) -->
              <ng-container *ngIf="coluna.pipe === 'liminar'">
                <span *ngIf="retornaValorCampo(item, coluna.campo)" class="badge badge-warning round">Sim</span>
                <span *ngIf="!retornaValorCampo(item, coluna.campo)" class="badge badge-secondary round">Não</span>
              </ng-container>
              <!-- ========================================================================= -->
              <!-- PIPE: EXPANDIR (Genérico para listas colapsáveis na célula)                -->
              <!-- Permite expandir múltiplos sub-itens (ex: empresas, dependentes, filiais)  -->
              <!-- Propriedades da Coluna:                                                    -->
              <!--   - campoLista: Nome da propriedade do item com a lista (default: empresas)-->
              <!--   - textoExpandir: Rótulo do link colapsável (default: 'Ver todos(as)')    -->
              <!--   - tituloExpandir: Cabeçalho do dropdown aberto (default: coluna.titulo)   -->
              <!-- ========================================================================= -->
              <ng-container *ngIf="coluna.pipe === 'expandir'">
                <!-- Cenário 1: Registro possui múltiplos sub-itens para expandir -->
                <ng-container *ngIf="(item[coluna.campoLista || 'itensExpandidos'] || item.empresas) && (item[coluna.campoLista || 'itensExpandidos'] || item.empresas).length > 0; else valorUnicoTabela">
                  <!-- Link de Abertura/Fechamento com Ícone Dinâmico -->
                  <div>
                    <a
                      href="javascript:void(0)"
                      class="text-info font-weight-bold d-inline-flex align-items-center"
                      style="text-decoration: none;"
                      (click)="item.expandido = !item.expandido; $event.stopPropagation()">
                      <i class="fa mr-1" [ngClass]="item.expandido ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      {{ coluna.textoExpandir || 'Ver todos(as)' }}
                    </a>
                  </div>

                  <!-- Container com a Lista de Itens Expandidos -->
                  <div
                    *ngIf="item.expandido"
                    class="mt-2 p-2 bg-light rounded border text-left font-small-2 shadow-sm"
                    (click)="$event.stopPropagation()">
                    <!-- Cabeçalho do Card com Título e Badge Contadora -->
                    <div class="d-flex justify-content-between align-items-center mb-1 pb-1 border-bottom text-muted font-weight-bold">
                      <span>{{ coluna.tituloExpandir || coluna.titulo || 'Itens:' }}</span>
                      <span class="badge badge-secondary round">{{ (item[coluna.campoLista || 'itensExpandidos'] || item.empresas).length }}</span>
                    </div>

                    <!-- Lista de Itens (com suporte a código, nome/descrição e status) -->
                    <div
                      *ngFor="let subItem of (item[coluna.campoLista || 'itensExpandidos'] || item.empresas)"
                      class="py-1 border-bottom d-flex justify-content-between align-items-center">
                      <span class="text-dark font-weight-bold">
                        {{ subItem.codigo ? subItem.codigo + ' - ' : '' }}{{ subItem.nome || subItem.descricao || subItem.titulo || subItem }}
                      </span>
                      <!-- Badge de Status individual do sub-item (quando disponível) -->
                      <span
                        *ngIf="subItem.status || item.status"
                        class="font-weight-bold ml-2 font-small-1"
                        [ngClass]="(subItem.status || item.status) === 'CONCLUÍDO' ? 'text-success' : 'text-danger'">
                        {{ subItem.status || item.status }}
                      </span>
                    </div>
                  </div>
                </ng-container>

                <!-- Cenário 2: Registro com valor único (exibição padrão de texto e status) -->
                <ng-template #valorUnicoTabela>
                  <div class="font-weight-bold text-dark font-small-3 text-uppercase">
                    {{ retornaValorCampo(item, coluna.campo) || item.empresaNome || '-' }}
                  </div>
                  <div
                    *ngIf="item.status"
                    class="font-weight-bold font-small-2 mt-1"
                    [ngClass]="item.status === 'CONCLUÍDO' ? 'text-success' : 'text-danger'">
                    {{ item.status }}
                  </div>
                </ng-template>
              </ng-container>
              <!-- Pipe Status Concluído / Pendente -->
              <ng-container *ngIf="coluna.pipe === 'status_concluido_pendente'">
                <span
                  class="font-weight-bold font-small-3"
                  [ngClass]="retornaValorCampo(item, coluna.campo) === 'CONCLUÍDO' ? 'text-success' : 'text-danger'">
                  {{ retornaValorCampo(item, coluna.campo) }}
                </span>
              </ng-container>
              <!--Pipe Badge Azul -->
              <ng-container *ngIf="adicionarBadge(coluna.pipe) || 'badge_azul' === coluna.pipe">
                <span
                  class="badge badge-info round"
                  style="
                    width: 141px !important;
                    height: 24px;
                    font-weight: 700;
                    text-transform: uppercase;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                  ">
                  {{ retornaValorCampo(item, coluna.campo) }}
                </span>
                </ng-container>
              <!--Pipe Badge Verde -->
              <ng-container *ngIf="adicionarBadge(coluna.pipe) || 'badge_verde' === coluna.pipe">
                <span
                  class="badge badge-success round"
                  style="
                    width: 141px !important;
                    height: 24px;
                    font-weight: 700;
                    text-transform: uppercase;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                  ">
                  {{ retornaValorCampo(item, coluna.campo) }}
                </span>
              </ng-container>
              <!--Pipe Badge SLA -->
              <ng-container *ngIf="coluna.pipe === 'badge_sla'">
                <span *ngIf="item.isSlaExpired" class="badge badge-danger round" style="font-weight: 700; text-transform: uppercase;">
                  Expirado
                </span>
                <span *ngIf="!item.isSlaExpired">
                  {{ retornaValorCampo(item, coluna.campo) }}
                </span>
              </ng-container>
              <!--Pipe BTN Auditoria -->
              <ng-container *ngIf="coluna.pipe === 'botao_auditoria'">
                <button
                  type="button"
                  [ngbTooltip]="'Visualizar Gravação: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                  class="btn btn-round box-shadow-4 btn-success"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.AUDITORIA, item)">
                  <i class="fa fa-list-ul darken-2"></i>
                </button>
              </ng-container>
              <!--Pipe BTN Valor -->
              <ng-container *ngIf="coluna.pipe === 'botao_valor'">
                <button
                  type="button"
                  ngbTooltip="Visualizar Valor(es)"
                  class="btn btn-round box-shadow-4 btn-success"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.VER_MODAL_VALOR, item)">
                  <i class="fa fa-money"></i>
                </button>
              </ng-container>
            </td>
            <!-- Status -->
            <td class="text-center" *ngIf="mostrarColunaStatus">
              <ng-container *ngIf="temPropriedadeLockout(item); else statusPadrao">
                <div *ngIf="item.lockoutEnabled" class="badge badge-danger round width-status-usuario">BLOQUEADO</div>
                <div *ngIf="!item.lockoutEnabled" class="badge badge-success round width-status-usuario">
                  DESBLOQUEADO
                </div>
              </ng-container>

              <!-- Correção: Adicionada a referência #statusPadrao -->
              <ng-template #statusPadrao>
                <div *ngIf="!item.active" class="badge badge-danger round width-padrao">INATIVO</div>
                <div *ngIf="item.active" class="badge badge-success round width-padrao">ATIVO</div>
              </ng-template>
                    <!-- Ações -->
            <td *ngIf="mostrarColunaAcao">
              <!-- somenteLeitura {{ somenteLeitura }} item.id {{ item.id }} mostrarBtnInativar {{ mostrarBtnInativar }} -->

              <div class="btn-group d-flex justify-content-center align-items-center" role="group">
                <!-- Editar -->
                <button
                  type="button"
                  *ngIf="mostraBtnEditar"
                  [ngbTooltip]="'Alterar: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                  tooltipClass="tooltip"
                  container="body"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.EDICAO, item)"
                  class="btn box-shadow-4 btn-warning"
                  [ngClass]="obterClasseBordaBotao('editar', item)">
                  <i class="ft-edit darken-2"></i>
                </button>
                <!-- Visualizar -->
                <button
                  type="button"
                  *ngIf="mostrarBtnVisualizar && item.canViewOccurrence !== false"
                  [ngbTooltip]="'Visualizar: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                  tooltipClass="tooltip"
                  container="body"
                  class="btn box-shadow-4 btn-info"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.VISUALIZAR, item)"
                  [ngClass]="obterClasseBordaBotao('visualizar', item)">
                  <i class="fa fa-eye"></i>
                </button>
                <!-- Reprocessar -->
                <button
                  type="button"
                  *ngIf="mostrarBtnReprocessar && (item.processingDate == null || item.processingDate === '-' || item.hasProcessingDate === false)"
                  [ngbTooltip]="'Reprocessar: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                  tooltipClass="tooltip"
                  container="body"
                  class="btn box-shadow-4 btn-warning"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.REPROCESSAR, item)"
                  [ngClass]="obterClasseBordaBotao('reprocessar', item)">
                  <i class="fa fa-refresh"></i>
                </button>
                <!-- Reversão -->
                <button
                  type="button"
                  *ngIf="mostrarBtnReverter"
                  [ngbTooltip]="'Reverter: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                  tooltipClass="tooltip"
                  container="body"
                  class="btn box-shadow-4 btn-danger"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.REVERTER, item)"
                  [ngClass]="obterClasseBordaBotao('reverter', item)">
                  <i class="fa fa-undo"></i>
                </button>
                <!-- Detalhes / Linha do Tempo -->
                <button
                  type="button"
                  *ngIf="mostrarBotaoHistorico"
                  [ngbTooltip]="'Ver Detalhes/Histórico'"
                  tooltipClass="tooltip"
                  container="body"
                  class="btn box-shadow-4 btn-secondary"
                  (click)="botaoAcaoClicado(i, item.id, item.active, 'DETALHES_TIMELINE', item)"
                  [ngClass]="obterClasseBordaBotao('historico', item)">
                  <i class="fa fa-history"></i>
                </button>
                <!-- Download -->
                <button
                  type="button"
                  *ngIf="mostrarBtnDowload"
                  [ngbTooltip]="'Baixar '"
                  tooltipClass="tooltip"
                  container="body"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.DOWNLOAD, item)"
                  class="btn box-shadow-4 btn-primary"
                  [ngClass]="obterClasseBordaBotao('download', item)">
                  <i class="fa fa-download"></i>
                </button>
                <!-- Ativar/Inativar ou Bloquear/Desbloquear -->
                <ng-container *ngIf="temPropriedadeLockout(item); else btnAtivarPadrao">
                  <!-- Botão com regra do lockoutEnabled (Usuário)-->
                  <button
                    type="button"
                    *ngIf="mostrarBotaoInativar(item)"
                    [ngbTooltip]="
                      (item.lockoutEnabled ? 'Desbloquear: ' : 'Bloquear: ') +
                      retornaValorCampo(item, colunasTabela[0].campo)
                    "
                    tooltipClass="tooltip"
                    container="body"
                    (click)="botaoAcaoClicado(i, item.id, item.lockoutEnabled, tipoAcao.ATIVAR_INATIVAR, item)"
                    class="btn box-shadow-4"
                    [ngClass]="[item.lockoutEnabled ? 'btn-success' : 'btn-danger', obterClasseBordaBotao('inativar', item)]">
                    <i
                      [ngClass]="{
                        'ft-unlock': item.lockoutEnabled,
                        'ft-lock': !item.lockoutEnabled
                      }"></i>
                  </button>
                </ng-container>

                <!-- Botão Padrão (Active) -->
                <ng-template #btnAtivarPadrao>
                  <button
                    type="button"
                    *ngIf="mostrarBotaoInativar(item)"
                    [ngbTooltip]="'Ativar/Desativar: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                    tooltipClass="tooltip"
                    container="body"
                    (click)="botaoAcaoClicado(i, item.id, !item.active, tipoAcao.ATIVAR_INATIVAR, item)"
                    class="btn box-shadow-4"
                    [ngClass]="[!item.active ? 'btn-success' : 'btn-danger', obterClasseBordaBotao('inativar', item)]">
                    <i
                      [ngClass]="{
                        'ft-unlock': !item.active,
                        'ft-lock': item.active
                      }"></i>
                  </button>
                </ng-template>
                <!-- Excluir -->
                <button
                  type="button"
                  *ngIf="mostrarBtnExcluir && !somenteLeitura"
                  tooltipClass="tooltip"
                  class="btn-danger btn box-shadow-4"
                  [ngClass]="obterClasseBordaBotao('excluir', item)"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.EXCLUIR, item)">
                  <i class="fa fa-trash"></i>
                </button>
                <!-- Selecionar -->
                <button
                  type="button"
                  *ngIf="item.mostrarBtnAcao"
                  [ngbTooltip]="'Selecionar: ' + retornaValorCampo(item, colunasTabela[0].campo)"
                  tooltipClass="tooltip"
                  container="body"
                  (click)="botaoAcaoClicado(i, item.id, item.active, tipoAcao.SELECIONAR, item)"
                  class="btn box-shadow-4 btn-primary"
                  [ngClass]="obterClasseBordaBotao('selecionar', item)">
                  <i class="fa fa-check-circle"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <app-table-footer [lista]="listaTabela"></app-table-footer>
    </div>
  </div>
  <!-- Paginação -->
  <div class="row mb-1" *ngIf="mostrarPaginacao">
    <div class="col-sm-12 col-md-5">
      <div class="dataTables_info" id="users-contacts_info" role="status" aria-live="polite">
        Exibindo {{ listaTabela?.length || 0 }} de {{ config?.totalItems || 0 }} Resultados.
      </div>
    </div>
    <div class="col-sm-12 col-md-7">
      <div class="dataTables_paginate paging_simple_numbers" id="users-contacts_paginate">
        <div class="d-flex justify-content-center">
          <pagination-controls
            id="{{ config.id }}"
            previousLabel="Anterior"
            nextLabel="Próximo"
            (pageChange)="onTablePageChange($event)"></pagination-controls>
        </div>
      </div>
    </div>
  </div>
</section>
